import React, { useState, useEffect } from 'react';
import '../css/OrderManagement.css';

const OrderManagement = ({ userRole = 'Admin', partnerId = null }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  // Simulated B2B Order Data Fetching Pipeline
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        // Real logic me yahan role ke dynamic check ke sath API query hit hogi
        // e.g., `http://localhost:5000/api/orders?role=${userRole}&partnerId=${partnerId}`
        
        const mockOrders = [
          {
            id: "ORD-98273",
            companyName: "Apex Wholesale Solutions",
            representative: "Rahul Sharma",
            totalItems: 45,
            totalAmount: 145000,
            paymentMode: "NEFT / Bank Transfer",
            utrReference: "UTR9283748291",
            status: "Pending Approval",
            createdAt: "2026-07-14"
          },
          {
            id: "ORD-47291",
            companyName: "BlueSky Distributors",
            representative: "Amit Verma",
            totalItems: 120,
            totalAmount: 489000,
            paymentMode: "Razorpay Online",
            utrReference: "pay_Rz8x7yZ291",
            status: "Paid & Dispatched",
            createdAt: "2026-07-12"
          },
          {
            id: "ORD-10928",
            companyName: "Vedic Retail Hub",
            representative: "Priya Patel",
            totalItems: 12,
            totalAmount: 34000,
            paymentMode: "UPI",
            utrReference: "UPI-82910283",
            status: "Cancelled",
            createdAt: "2026-07-10"
          }
        ];
        
        setOrders(mockOrders);
      } catch (err) {
        console.error("Error loading B2B orders pipeline:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [userRole, partnerId]);

  // Order status transition actions (Admin privilege)
  const handleUpdateStatus = (orderId, nextStatus) => {
    if (!window.confirm(`Confirm order status transmission to: ${nextStatus}?`)) return;
    
    setOrders(prevOrders => 
      prevOrders.map(order => 
        order.id === orderId ? { ...order, status: nextStatus } : order
      )
    );
    alert(`Order ${orderId} successfully updated to ${nextStatus}!`);
  };

  // Filter & Search Logic
  const filteredOrders = orders.filter(order => {
    const matchesStatus = filterStatus === 'All' || order.status.includes(filterStatus);
    const matchesSearch = 
      order.id.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.companyName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.utrReference.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  return (
    <div className="order-master-container">
      <div className="order-dashboard-header">
        <div>
          <span className="badge-scope">{userRole.toUpperCase()} CONTROL PANEL</span>
          <h1>B2B Order Logistics Hub</h1>
        </div>
        <div className="search-box-wrapper">
          <input 
            type="text" 
            placeholder="Search by Order ID, Company, or UTR..." 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="order-search-input"
          />
        </div>
      </div>

      {/* Dynamic Status Nav Tabs */}
      <div className="order-tabs-row">
        {['All', 'Pending Approval', 'Paid & Dispatched', 'Cancelled'].map(tab => (
          <button 
            key={tab} 
            className={`tab-btn ${filterStatus === tab ? 'active-tab' : ''}`}
            onClick={() => setFilterStatus(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Main Table Pipeline */}
      <div className="order-table-card">
        {loading ? (
          <div className="order-loader">Syncing Active Order Pipelines... 🔄</div>
        ) : filteredOrders.length === 0 ? (
          <div className="empty-order-state">No matching orders found under this registry filter.</div>
        ) : (
          <table className="b2b-order-table">
            <thead>
              <tr>
                <th>Order Details</th>
                <th>Purchaser Entity</th>
                <th>Financial Metrics</th>
                <th>Payment Clearance</th>
                <th>Logistics Status</th>
                {userRole === 'Admin' && <th>Operational Actions</th>}
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map(order => (
                <tr key={order.id}>
                  <td>
                    <span className="order-id-txt">{order.id}</span>
                    <span className="order-date-txt">Logged: {order.createdAt}</span>
                  </td>
                  <td>
                    <strong>{order.companyName}</strong>
                    <span className="sub-rep-txt">Agent/Rep: {order.representative}</span>
                  </td>
                  <td>
                    <span className="amount-txt">₹{order.totalAmount.toLocaleString('en-IN')}</span>
                    <span className="qty-txt">{order.totalItems} Bulk Units</span>
                  </td>
                  <td>
                    <span className="pay-mode">{order.paymentMode}</span>
                    <span className="utr-badge">Ref: {order.utrReference}</span>
                  </td>
                  <td>
                    <span className={`status-pill ${order.status.toLowerCase().replace(/\s+/g, '-')}`}>
                      {order.status}
                    </span>
                  </td>
                  {userRole === 'Admin' && (
                    <td>
                      <div className="order-action-cluster">
                        {order.status === 'Pending Approval' && (
                          <>
                            <button 
                              className="act-btn btn-verify" 
                              onClick={() => handleUpdateStatus(order.id, 'Paid & Dispatched')}
                            >
                              Approve & Dispatch 🚀
                            </button>
                            <button 
                              className="act-btn btn-void" 
                              onClick={() => handleUpdateStatus(order.id, 'Cancelled')}
                            >
                              Void Order ❌
                            </button>
                          </>
                        )}
                        {order.status === 'Paid & Dispatched' && (
                          <span className="lock-state-txt">Dispatched 🔒</span>
                        )}
                        {order.status === 'Cancelled' && (
                          <span className="lock-state-txt voided">Archived 🚫</span>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default OrderManagement;